// extracted by mini-css-extract-plugin
export default {"services_container":"ServiceList_services_container__MBjEY","service_ct":"ServiceList_service_ct__TdURx","icon_circle":"ServiceList_icon_circle__Cj4R4"};